module.exports = __webpack_public_path__ + "2939449eba3abebcff8b85f81940ff9f.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/809.png
// module id = 1712
// module chunks = 2